export const activities = [
    {
        id: "stanford-gnn",
        name: "Stanford CS224W",
        provider: "YouTube",
        progress: 100,
        totalItems: 60,
        completedItems: 60,
        link: "https://www.youtube.com/playlist?list=PLoROMvodv4rPLKxIpqhjhPgdQy7imNkDn",
        color: "#FF0000" // Red
    },
    {
        id: "dl-specialization-coursera",
        name: "Deep Learning Specialization",
        provider: "Coursera",
        progress: 100,
        totalItems: 5,
        completedItems: 5,
        link: "https://www.coursera.org/specializations/deep-learning",
        color: "#0056D2" // Blue
    },
    {
        id: "tensorflow-developer-coursera",
        name: "TensorFlow Developer Professional Certificate",
        provider: "Coursera",
        progress: 100,
        totalItems: 4,
        completedItems: 4,
        link: "https://www.coursera.org/professional-certificates/tensorflow-in-practice",
        color: "#0056D2" // Blue
    },
    {
        id: "neetcode-150",
        name: "NeetCode 150",
        provider: "NeetCode",
        progress: 100,
        totalItems: 150,
        completedItems: 150,
        link: "https://neetcode.io/roadmap",
        color: "#6A5FB0"
    },
    {
        id: "rl-deepmind",
        name: "Reinforcement Learning - DeepMind x UCL",
        provider: "YouTube",
        progress: 100,
        totalItems: 10,
        completedItems: 10,
        link: "https://youtube.com/playlist?list=PLqYmG7hTraZDM-OYHWgPebj2MfCFzFObQ&si=5OE2XcMAfWxmLSZD",
        color: "#FF0000" // Red
    }
];